import React from "react";
import Highcharts, { SeriesAreasplineOptions } from "highcharts";
import HighchartsReact from "highcharts-react-official";

export interface LineGraphInterface {
  //TODO: add actual interface instead if test interface
  name?: string;
  "Active Patients": number;
  "Inactive Patients": number;
  "Admitted": number;
  "Discharged": number;
  "RPM Time": number;
  "Interviened": number;
  "Flow(L/s)": number;
  "Max Flow(L/s)": number;
}
export type CustomLineGraphProps = {
  data: LineGraphInterface[];
  chart: string;
  view?: string;
};
const createAreaSeries = (name: string, color: string, values: number[]): SeriesAreasplineOptions => ({
  type: "areaspline",
  name,
  data: values,
  lineColor: color,
  color: {
    linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
    stops: [
      [0.05, Highcharts.color(color).setOpacity(1).get() as string],
      [0.95, Highcharts.color(color).setOpacity(0).get() as string],
    ],
  },
  marker: { enabled: false },
});

export const StyledLineGraph: React.FC<CustomLineGraphProps> = ({
  data,
  chart,
  view
}) => {
  let series: SeriesAreasplineOptions[] = [];
  if (chart === "overview") {
    if (view === "activePatients") {
      series = [
        createAreaSeries("Active Patients", "#8884d8", data.map(entry => entry["Active Patients"] ?? 0)),
        createAreaSeries("Inactive Patients", "#82ca9d", data.map(entry => entry["Inactive Patients"] ?? 0)),
      ];
    } else if (view === "admitionStatus") {
      series = [
        createAreaSeries("Admitted", "#8884d8", data.map(entry => entry["Admitted"])),
        createAreaSeries("Discharged", "#82ca9d", data.map(entry => entry["Discharged"])),
      ];
    } else if (view === "timeRPM") {
      series = [
        createAreaSeries("RPM Time", "#8884d8", data.map(entry => entry["RPM Time"])),
      ];
    }
  } else if (chart === "group") {
    if (view === "groups") {
      series = [
        createAreaSeries("RPM Time", "#8884d8", data.map(entry => entry["RPM Time"])),
      ];
    }
  } else if (chart === "program") {
    //TODO
  } else if (chart === "coordinator") {
    series = [
      createAreaSeries("RPM Time", "#8884d8", data.map(entry => entry["RPM Time"])),
    ];
  } else if (chart === "patient") {
    series = [
      createAreaSeries("RPM Time", "#8884d8", data.map(entry => entry["RPM Time"])),
    ];
  } else if (chart === "devices") {
    series = [
      createAreaSeries("RPM Time", "#8884d8", data.map(entry => entry["RPM Time"])),
      createAreaSeries("Interviened", "#82ca9d", data.map(entry => entry["Interviened"])),
    ];
  } else if (chart === "spir") {
    series = [
      createAreaSeries("Max Flow(L/s)", "#8884d8", data.map(entry => entry["Max Flow(L/s)"])),
      createAreaSeries("Flow(L/s)", "#82ca9d", data.map(entry => entry["Flow(L/s)"])),
    ];
  }
  const options: Highcharts.Options = {
    chart: {type: "areaspline", height: 250},
    title: {text: undefined},
    xAxis: {
      categories: data.map(entry => entry.name ?? ""),
      gridLineDashStyle: "Dash",
    },
    yAxis: { title: {text: undefined} },
    tooltip: {shared: true},
    legend: {verticalAlign: "top", layout: "horizontal"},
    series,
  };
  return (
      <HighchartsReact highcharts={Highcharts} options={options} />
  );
};
